/**
 * Checking if the user is admin? This is already computed for you:
 *
 * const { isAdmin } = useSelector(selectUserAttributesState, shallowEqual);
 */
const canAccessFeature = (userRoles, allowedRoles) =>
  userRoles?.some((userRole) => allowedRoles.includes(userRole));

export default canAccessFeature;
